<section class="winols-search-card" aria-label="Search by WinOLS reference">
  <div class="search-row">
    <i class="bi bi-search search-icon" aria-hidden="true"></i>
    <input
      type="search"
      [formControl]="searchControl"
      (focus)="onFocus()"
      (keydown)="onKeydown($event)"
      aria-label="Search Pure Originals and Masters by WinOLS reference"
      [attr.aria-expanded]="isOpen()"
      placeholder="Search Pure Originals and Masters by WinOLS reference"
      autocomplete="off">
    <span class="search-hint" *ngIf="!searchControl.value">WinOLS reference</span>
    <button *ngIf="searchControl.value" type="button" class="clear-button" (click)="clearSearch()" aria-label="Clear search">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="search-results" *ngIf="isOpen()" aria-live="polite">
    <div class="results-heading" *ngIf="!isLoading() && !hasError() && results().length > 0">
      <span>Results</span>
      <span>{{ totalResults() }} found</span>
    </div>

    <p class="search-message" *ngIf="isLoading()">Searching…</p>
    <p class="search-message" *ngIf="!isLoading() && hasError()">Search could not be loaded. Please try again.</p>
    <p class="search-message" *ngIf="!isLoading() && !hasError() && results().length === 0">No matching files found.</p>

    <div class="result-list" *ngIf="!isLoading() && results().length > 0">
      <button
        type="button"
        class="result-item"
        *ngFor="let result of results(); trackBy: trackResult"
        (click)="openResult(result)">
        <span class="result-main">
          <span class="result-reference" [title]="resultReference(result)">{{ resultReference(result) }}</span>
          <span class="result-detail" [title]="resultDetail(result)">{{ resultDetail(result) }}</span>
        </span>
        <span class="result-type">{{ resultLabel(result) }}</span>
        <i class="bi bi-arrow-up-right result-arrow" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</section>
